<template>
  <div class="carousel_wrap">
    <el-carousel @change="change" height="88vh" :interval="3000" loop arrow="hover" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img v-if="index === 1" :src="item.src" alt="" class="img_item" :class="activeIndex === index ? 'active': ''" />
        <video ref="videoPlayer" v-if="index === 0"
               autoplay
               muted
               loop
               playsinline class="video_item" :class="activeIndex === index ? 'active': ''">
          <source :src="item.src" type="video/mp4">
        </video>
        <div class="tips_font">
          <h1 v-animate-on-scroll="'animate__fadeInDown:delay:0'">{{ item.line1 }}</h1>
          <h2 style="margin-top: 10px;" v-animate-on-scroll="'animate__fadeInUp:delay:1'">{{ item.line2 }}</h2>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel @change="change" height="50vw" loop :interval="3000" arrow="hover" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img v-if="index === 1" :src="item.src" alt="" class="img_item" :class="activeIndex === index ? 'active': ''" />
        <video ref="videoPlayer" v-if="index === 0"
               autoplay
               muted
               loop
               playsinline class="video_item" :class="activeIndex === index ? 'active': ''">
          <source :src="item.src" type="video/mp4">
        </video>
        <div class="tips_font">
          <h1 v-animate-on-scroll="'animate__fadeInDown:delay:0'">{{ item.line1 }}</h1>
          <h2 v-animate-on-scroll="'animate__fadeInUp:delay:1'">{{ item.line2 }}</h2>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  computed: {
    imgList()
    {
      return [
      {
        src: require('@/assets/home_compressed.mp4'),
        // src: require('@/assets/img/home/banner2.png'),
        line1: this.$t("homeAbout.banner1Describe1"),
        line2: this.$t("homeAbout.banner1Describe2"),
      },
      {

        src: require('@/assets/img/home/banner1.png'),
        line1: this.$t("homeAbout.banner2Describe1"),
        line2: this.$t("homeAbout.banner2Describe2"),
      }]
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  mounted() {},
  methods: {
    change(index) {
      if(this.activeIndex !== index){
        setTimeout(() => {
          this.activeIndex = index
        },300)
      }
    },
  },
}
</script>

<style lang="scss">
.carousel_wrap {
  font-family: $font-family;
  position: relative;
  text-align: center;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .video_item{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    z-index: 5;
    color: #fff;
    font-size: 30px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
  .img_item{
    transform: scale(1.08);
    &.active{
      animation: myAnimation 3s forwards;
      transition: all 3s;
    }
  }
  @keyframes myAnimation {
    0% { transform: scale(1); }
    100% { transform: scale(1.08); }
  }

  //.video_item{
    //transform: scale(1.08);
    //&.active{
      //animation: myAnimation 3s forwards;
      //transition: all 3s;
    //}
  //}

}
</style>
